<template>
  <div class="news-container">
    <div class="news-top">
      <carousel :list="bannerList"/>
    </div>
    <div class="news-main">
      <dynamicList/>
      <service />
    </div>
  </div>
</template>

<script setup>
import {ref} from "vue";
import carousel from '@/components/carousel/index.vue'
import {getBannerList} from "@/api/apiHome";
import dynamicList from './components/dynamicList.vue'
import service from './components/service.vue'
const bannerList = ref([])
const queryBannerList = async () => {
  const {code, data} = await getBannerList(3)
  if (code === 200) {
    bannerList.value = data
  }
}
queryBannerList()
</script>

<style lang="scss" scoped>

.news-top {
  width: 100%;
  height: 540px;
  overflow: hidden;
}
.news-main{
  width: 100%;
  box-sizing: border-box;
}

</style>
